import React from 'react';
import { CssBaseline, Box } from '@mui/material';
import { ThemeProvider } from './contexts/ThemeContext';
import Header from './components/Header';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import ExperienceSection from './components/ExperienceSection';
import PublicationsSection from './components/PublicationsSection';
import MediumListsSection from './components/MediumListsSection';
import RecommendationsSection from './components/RecommendationsSection';
// import ContactSection from './components/ContactSection';
import Footer from './components/Footer';
import ThemeSwitcher from './components/ThemeSwitcher';
import FloatingIIMCLogo from './components/FloatingIIMCLogo';
import GoToTopButton from './components/GoToTopButton';
import FloatingRobot from './components/FloatingRobot';
// import AnnouncementModal from './components/AnnouncementModal';

function App() {
  return (
    <ThemeProvider>
      <CssBaseline />
      <div style={{ position: 'relative' }}>
        <Header />
        <FloatingIIMCLogo />
      </div>
      
      {/* Floating Theme Switcher */}
      <Box sx={{ 
        position: 'fixed', 
        bottom: { xs: 88, md: 104 }, // Position above chat agent
        left: { xs: 16, md: 24 }, // Left corner
        zIndex: 1301 
      }}>
        <ThemeSwitcher />
      </Box>

      {/* Floating Go to Top Button */}
      <GoToTopButton />

      <main>
        <HeroSection />
        <AboutSection />
        <ExperienceSection />
        <PublicationsSection />
        <MediumListsSection />
        <RecommendationsSection />
        <FloatingRobot />
        <Footer />
      </main>
    </ThemeProvider>
  );
}

export default App; 